import {connect} from 'react-redux';
import {RunGelBox as Component} from './RunGelBox';
import {
  showModal,
  runGel
} from '@learningblocks/protocol-redux/lib/Actions';

function mapStateToProps(state) {
  return {
    //solutions: state.notebook.protocolSection.scene.apparatus.solutions
  }
}

function mapDispatchToProps(dispatch) {
  return {
    showModal: (data) => {
      dispatch(showModal(data))
    },
    runGel: (data) => {
      dispatch(runGel(data))
    }
  };
}

export const RunGelBox = connect(
  mapStateToProps,
  mapDispatchToProps
)(Component);
